import { useEffect, useState } from 'react';

export default function useWindowWidth() {
  const [windowWidth, setWindowSize] = useState(null);
  useEffect(() => {
    setWindowSize(window.innerWidth);
  }, []);
  return windowWidth;
}
